module.exports = __webpack_public_path__ + "static/media/9246 Kiefer Sketch.88168697.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/9246 Kiefer Sketch.jpg
// module id = 410
// module chunks = 0